<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="position-absolute w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div class="row position-relative m-0 p-2 background-primary-blue height-70px shadow z-3 d-flex justify-content-center align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto row">
            @if (!loading) {
                <div class="col-8 fs-main text-center color-white">Precipitation sample points</div>
            }
            <div class="col-4 d-flex justify-content-center">
        <span><app-precipitation-svg [height]="'20px'"
                                     [online]="true"
                                     [width]="'20px'"
                                     class="img-fluid img-max m-auto"></app-precipitation-svg></span>
                <span class="color-white p-1">{{ filteredPrecipitationSamplePoints().length }}</span>
            </div>
        </div>
        <div class="col-2 d-flex justify-content-center align-items-center">
            <div (click)="close()" class="pointer text-reset">
                <i class="color-white fa-solid fa-x fa-xl"></i>
            </div>
        </div>
    </div>
    <div class="p-3 background-white">
        <div class="mb-3">
            <div class="input-group position-relative">
                <input (input)="filterResults($event.target)"
                       class="form-control m-auto rounded-pill height-50px ps-3 pe-3"
                       placeholder="Search..."
                       style="padding-right: 30px;"
                       type="search">
                <i class="fa-solid fa-magnifying-glass"
                   style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
            </div>
        </div>
        @if (filteredPrecipitationSamplePoints().length == 0) {
            <div class="text-center p-3 opacity-50">
                <div>No precipitation points defined</div>
            </div>
        } @else {
            <div>
                @for (precipitationSamplePoint of filteredPrecipitationSamplePoints(); track precipitationSamplePoint.id) {
                    <app-precipitation-point-button [id]="precipitationSamplePoint.id"/>
                }
            </div>
        }
    </div>
</div>
